import { useDebouncedListingsFilterCall } from '@mfs/client/listings-client/components/Filters/useDebouncedListingsFilterCall/useDebouncedListingsFilterCall'
import { useAirlinesFilters } from '../AirlinesFilters/hooks/useAirlinesFilters'
import { useAirportsFilters } from '../AirportsFilters/hooks/useAirportsFilters'
import { updateFilters } from '../DynamicFilters/helpers'
import { initializeAirportFilters } from '../RecommendedFilters/helpers/getRecommendedFilters'
import { useStopsFilters } from '../StopsFilters/hooks/useStopsFilters'
import { useTimeDispatch } from '../TimeFilters/Hooks/UseTimeDispatch'
import { useAttributeFilters } from '../AttributesFilters/hooks/useAttributeFilters'

/**
 * Initialize the change handlers from different filters
 * Bind them to a single generic click handler
 *
 * @param {*} param0
 * @returns Click handler for chip
 */
export function useChangeHandlers({
  currentMobileFilter,
  pclnBootstrapData,
  activeTabId,
  selected,
  setSelected,
  searchRequest,
  isRecommended,
  timebands,
}) {
  const { debouncedListingsFilterCall } = useDebouncedListingsFilterCall()

  // Filters Change handler
  const changeHandler = () => {
    if (!currentMobileFilter) {
      debouncedListingsFilterCall(pclnBootstrapData, 'filter')
    }
  }

  const isDynamic = !isRecommended

  /**
   * Stops Filters
   */
  const { stopsHandleChange: handleStopsChange } = useStopsFilters({
    changeHandler,
    isDynamic,
  })

  /**
   * Airline Filters
   */
  const { airlineHandleChange: handleAirlineChange } = useAirlinesFilters({
    changeHandler,
    isDynamic,
    isRecommended,
  })

  /**
   * Time Filters
   */
  const { handleTimeChipClick } = useTimeDispatch({
    changeHandler,
    activeTabId,
    isDynamic,
  })

  /**
   * Airport Filters
   */
  const { originFilter, destinationFilter } = useAirportsFilters({
    changeHandler,
    isDynamic,
    isRecommended,
  })

  /**
   * Attributes Filters
   */
  const { attributeHandleChange: handleAttributeChange } = useAttributeFilters({
    changeHandler,
  })

  /**
   * Click Handler
   */
  const handleClick = ({ type, filterId, isSelectedFromState }) => {
    let identifier = type + '_' + filterId

    setSelected({
      ...selected,
      [identifier]: !isSelectedFromState,
    })

    let airportsFilter = initializeAirportFilters({
      originFilter,
      destinationFilter,
      filterId,
    })

    updateFilters({
      isSelectedFromState,
      type,
      filterId,
      handleStopsChange,
      handleAirlineChange,
      handleTimeChipClick,
      handleAttributeChange,
      airportsFilter,
      activeTabId,
      date: searchRequest?.slices?.[activeTabId - 1]?.travelDate,
      timebands,
    })
  }

  return {
    originFilter,
    destinationFilter,
    handleClick,
  }
}
